export const CONNECTION_ERROR = 'CONNECTION_ERROR';
export const OK = 200;
export const CREATED = 201;
export const NO_CONTENT = 204;
export const BAD_REQUEST = 400;
export const NOT_FOUND = 404;
export const UNPROCESSABLE_ENTITY = 422;
